import { FC, SVGAttributes } from 'react';

const OutlinedMinus: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6 8.35C5.64101 8.35 5.35 8.64102 5.35 9C5.35 9.35898 5.64101 9.65 6 9.65V8.35ZM12 9.65C12.359 9.65 12.65 9.35898 12.65 9C12.65 8.64102 12.359 8.35 12 8.35V9.65ZM9 15.1C5.63106 15.1 2.9 12.3689 2.9 9H1.6C1.6 13.0869 4.91309 16.4 9 16.4V15.1ZM2.9 9C2.9 5.63106 5.63106 2.9 9 2.9V1.6C4.91309 1.6 1.6 4.91309 1.6 9H2.9ZM9 2.9C12.3689 2.9 15.1 5.63106 15.1 9H16.4C16.4 4.91309 13.0869 1.6 9 1.6V2.9ZM15.1 9C15.1 12.3689 12.3689 15.1 9 15.1V16.4C13.0869 16.4 16.4 13.0869 16.4 9H15.1ZM6 9.65H12V8.35H6V9.65Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default OutlinedMinus;
